import React from 'react';
import {reactDOMInject} from 'common/utils/dom-util';
import Dashboard from 'common/components/dashboard';
import './index.scss';

let props;

reactDOMInject(Dashboard, '#dashboard', (data) => {
  props = {
    dashboard: JSON.parse(data.dashboard),
    readonly: JSON.parse(data.readonly),
    userCanEditDashboard: JSON.parse(data.userCanEditDashboard),
  };
  return props;
});

window.addEventListener('dashboard-settings-updated', (evnt) => {
  const {dashboard, userCanEditDashboard} = evnt.detail;

  props = {
    ...props,
    dashboard,
    userCanEditDashboard,
  };

  reactDOMInject(Dashboard, '#dashboard', () => props);
});
